export enum LOCATIONS_DICTIONARY_PAGE_TAB_KEYS {
  ALL = "",
  CITY = "CITY",
  PORT = "PORT",
  RAILWAY = "RAILWAY",
  UNKNOWN = "UNKNOWN",
}
